"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _intlDesignUi = require("@tencent/intl-design-ui");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var _formatVodData2 = require("../../utils/formatVodData");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const formatList = list => {
  const configuration = list.map((item, index) => {
    const _item$backgroundImage = item.backgroundImage,
      backgroundImage = _item$backgroundImage === void 0 ? '' : _item$backgroundImage,
      linkText = item.linkText,
      link = item.link;
    const _formatVodData = (0, _formatVodData2.formatVodData)(backgroundImage),
      formatBackgroundImage = _formatVodData.url;
    return _objectSpread(_objectSpread({}, item), {}, {
      backgroundImage: formatBackgroundImage,
      extendProps: {
        'report-event-goal': 'click_activityCard',
        'report-event': 'click_activityCard_href',
        'report-ext1': index,
        'report-ext2': linkText,
        'report-ext3': link
      }
    });
  });
  return configuration;
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const componentData = data;
  if (componentData) {
    const porintId = data.porintId,
      _data$modTitle = data.modTitle,
      modTitle = _data$modTitle === void 0 ? '' : _data$modTitle,
      _data$desc = data.desc,
      desc = _data$desc === void 0 ? '' : _data$desc,
      _data$color = data.color,
      color = _data$color === void 0 ? '' : _data$color,
      _data$list = data.list,
      list = _data$list === void 0 ? [] : _data$list;
    const resultList = formatList(list);
    const bgStyle = {};
    if (color) {
      bgStyle.background = color;
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId
    }, (0, _reportUtil.reportShow)(['show_activityCard', componentKey, porintId]), {
      style: bgStyle
    }), /*#__PURE__*/React.createElement(_intlDesignUi.Section, {
      col: 4,
      title: modTitle,
      desc: desc
    }, /*#__PURE__*/React.createElement(_intlDesignUi.ActivityCard, {
      ActivityList: resultList
    })));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
}